export default class User {
    // access: { all, groups, cities, unit_types, enforced } from api/current_user
    // (user_access_api.inc). UX only — the backend is the authority.
    constructor (bc_access, first_name, last_name, mail, role, status, uid, access = null, is_super_admin = undefined){
        this.bc_access = bc_access
        this.first_name = first_name;
        this.last_name = last_name;
        this.mail = mail;
        this.role = role;
        this.status = status;
        this.uid = uid;
        this.access = access;
        // undefined when the backend predates the flag; isSuperAdmin() in
        // variables.js then falls back to its email list.
        this.is_super_admin = typeof is_super_admin === "boolean" ? is_super_admin : undefined;
    }
}